import { render, staticRenderFns } from "./FormSetCamera.vue?vue&type=template&id=5d37aa48"
import script from "./FormSetCamera.vue?vue&type=script&lang=js"
export * from "./FormSetCamera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports